module.exports = __webpack_public_path__ + "assets/img/kristijonas.1e07f6c7.webp";